// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-global-policy-pre-content-rule-missing-company-name',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    template: `
        <div class="mt-4 mx-4" ngModelGroup="ruleMissingCompanyName">
            <div class="row">
                <div class="col-24 col-md-30">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <div class="font-size-1-3 font-weight-300" translate>Policy setup</div>
                        </div>
                        <div class="card-body">
                            <div class="form-group mb-0">
                                <!-- TODO: Update old style format for Bootstrap forms, https://zube.io/monsido/monsido/c/22962 -->
                                <label for="policy-pre-content-inputfield" class="col-sm-8 control-label mt-1 capitalize-first-letter" translate>
                                    Company name *
                                </label>
                                <div class="col-sm-40">
                                    <input [(ngModel)]="ngModel"
                                           name="companyName"
                                           type="text"
                                           class="form-control"
                                           id="policy-pre-content-inputfield"
                                           placeholder="{{ 'Insert company name' | translate }}"
                                           (ngModelChange)="onModelChange()"
                                           required/>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-sm-40 mt-2">
                                    <!-- TODO: Update old style format for Bootstrap forms, https://zube.io/monsido/monsido/c/22962 -->
                                    <label for="policy-pre-content-inputfield" class="col-sm-8 control-label mt-1 capitalize-first-letter" translate>
                                        Letter case *
                                    </label>
                                    <label class="radio-inline mr-2" *ngFor="let letterType of letterTypes">
                                        <input [(ngModel)]="type"
                                               name="letterType"
                                               (ngModelChange)="onModelChange()"
                                               type="radio"
                                               [value]="letterType.value">
                                        <span>{{letterType.name}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-24 col-md-18">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <div class="font-size-1-3 font-weight-300" translate>
                                Information
                            </div>
                        </div>
                        <div class="card-body pt-3">
                            <p>
                                <strong translate>How to setup this policy</strong>
                            </p>
                            <p translate>To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormGlobalPolicyPreContentRuleMissingCompanyNameComponent implements OnInit {
    @Input() model: any;

    ngModel: any = null;
    type: any = null;
    letterTypes: any[] = [];
    contentController: any;

    constructor (
        private monDialog: MonDialog,
        private translateService: TranslateService,
    ) {}

    ngOnInit () {
        this.ngModel = null;
        this.type = null;
        this.letterTypes = [
            {
                value: null,
                name: this.translateService.getString('Custom'),
            },
            {
                value: 'lowercase',
                name: this.translateService.getString('lowercase'),
            },
            {
                value: 'uppercase',
                name: this.translateService.getString('UPPERCASE'),
            },
            {
                value: 'propercase',
                name: this.translateService.getString('Proper Case'),
            },
        ];
    }

    onModelChange () {
        if (typeof this.ngModel === 'string') {
            const scope = {
                company: this.ngModel,
            };
            switch (this.type) {
                case 'lowercase':
                    scope.company = this.ngModel.toLowerCase();
                    break;
                case 'uppercase':
                    scope.company = this.ngModel.toUpperCase();
                    break;
                case 'propercase':
                    scope.company = this.ngModel.replace(/\w\S*/g, (txt) =>
                        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
                    );
                    break;
            }
            this.model = [
                {
                    name: this.translateService.getString('Check for misspelling company name: [[company]]', scope),
                    case_sensitive: true,
                    inverse: false,
                    operator: 'contains',
                    query: scope.company,
                    type: 'page_text',
                    sub_entry: '',
                },
            ];
        } else {
            this.model = null;
        }
    }
}
